import {
  ChangeDetectionStrategy, ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  HostBinding,
  HostListener,
  Input,
  OnInit,
  Output,
  ViewContainerRef,
} from "@angular/core";

@Component({
  selector: 'input[int-default-input-field], textarea[int-default-input-field]',
  template: '',
  styles: [`
    :host {
      display: block;
      width: 100%;
      height: 100%;
      font-size: inherit;
      font-family: inherit;
      color: currentColor;
      outline: transparent;
      border: none;
      /*padding-top: var(--int-default-input-field-padding-top, 0);*/
      /*padding-right: var(--int-default-input-field-padding-right, 0);*/
      /*padding-bottom: var(--int-default-input-field-padding-bottom, 0);*/
      /*padding-left: var(--int-default-input-field-padding-left, 0);*/
      background-color: transparent;
      border-radius: 0.2rem;
    }
  `],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class IntDefaultInputField implements OnInit {
  @Output() onFocus = new EventEmitter();
  @Output() onBlur = new EventEmitter();
  @Output() onInput = new EventEmitter();

  @HostListener('focus', ['$event']) _setFocus() {
    this.onFocus.emit();
  }
  @HostListener('blur', ['$event']) _setBlur() {
    this.onBlur.emit();
  }
  @HostListener('input', ['$event']) _onInput(event: any) {
    this.onInput.emit(event.target.value);
  }

  @HostBinding('value')
  @Input() value = ''

  @HostBinding('disabled')
  @Input()
  disabled: boolean = false;

  @HostBinding('readonly')
  @Input()
  readonly: boolean = false;

  get currentValue(): string {
    return this.elementRef.nativeElement.value;
  }

  constructor(
    readonly vcr: ViewContainerRef,
    readonly elementRef: ElementRef,
    readonly cdr: ChangeDetectorRef
  ) {
  }

  ngOnInit() {

  }
}
